import Vue from 'vue';
import Router from 'vue-router';

const Page404 = () => import('@/components/views/Page404');
const Page401 = () => import('@/components/views/Page401');
const Text = () => import('@/components/views/Text');
const Docs = () => import('@/components/views/Docs');
const Docs2 = () => import('@/components/views/Docs2');

Vue.use(Router);
export default new Router({
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes(){
  return [
    {
      path: '/',
      name: 'Text',
      component: Text
    },
    {
      path: '/docs',
      name: 'Docs',
      component: Docs
    },
    {
      path: '/docs2',
      name: 'Docs2',
      component: Docs2
    },
    {
      path: '/401',
      name: 'Page 401',
      component: Page401
    },
    {
      path: '/*',
      name: 'Page 404',
      component: Page404
    }
  ]
}
